import * as React from "react";
import type { SVGProps } from "react";
const SvgGear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.353 6.6 12 1.2 2.647 6.6v10.8L12 22.8l9.353-5.4zM12 15.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGear;
